import { ReactNode } from 'react';

interface QuestionnaireLayoutProps {
  children: ReactNode;
  topElement?: ReactNode;
  bottomElement?: ReactNode;
  fullHeightWhenCTAIsHidden?: boolean;
}

export const QuestionnaireLayout = ({
  children,
  bottomElement,
  fullHeightWhenCTAIsHidden,
}: QuestionnaireLayoutProps) => {
  return (
    <div className="relative w-full h-full flex flex-col items-center ">
      <div
        className={`w-full h-full flex flex-col ${
          fullHeightWhenCTAIsHidden ? 'pb-0' : 'pb-24 nsm:pb-0'
        } `}
      >
        {children}
      </div>

      {/* Desktop bottom element*/}
      <div className="absolute bottom-0 left-0 right-0 w-full sm:hidden flex items-center justify-center">
        <div className="flex items-center justify-center w-full nmd:w-116 nxl:w-162">
          {bottomElement}
        </div>
      </div>

      {/* Mobile bottom element */}
      <div
        className={`fixed bottom-0 left-0 right-0 hidden sm:flex w-full items-center justify-center ${
          fullHeightWhenCTAIsHidden ? '' : 'py-3'
        }`}
      >
        {bottomElement}
      </div>
    </div>
  );
};
